<template>
    <div class="about_the_initiative-container general-container">
        <p class="about_the_initiative">
            A kézfogás a magánéletben a barátság, az üzleti életben pedig a megállapodás és az elégedettség szimbóluma. A koronavírus járványt követően mindennél jobban esik majd kezet fogni egymással. Amíg ezt nem tehetjük meg, lehetőséget szeretnénk biztosítani azoknak, akik hajlandóak segítő kezet nyújtani kedvenc kisvállalkozásaiknak, helyi szolgáltatóiknak, vagy szeretett művészeiknek.</p>
        <p> A Kollektíva  elindításával az volt a célunk, hogy a jelenlegi vészhelyzetben egyáltalán nem működő, stagnáló és jelentős anyagi veszteséget elszenvedő vállalkozásoknak és az őket támogatni kívánó vásárlóközönségnek létrehozzunk egy közös támogató felületet.</p>   
        <h3>Kiknek segíthetünk? </h3>
            <ul>
                <li>helyi kisvállalkozásoknak</li>
                <li>ismerős vállalkozóknak</li>
                <li>szeretett zenekaroknak és előadóművészeknek</li>
            </ul>

        <p>A fentiek közül is különösen azoknak, akik:</p>
            <ul>
                <li>eddig nem rendelkeztek honlappal, közösségi oldallal vagy online vásárlói felülettel</li>
                <li>piacon maradása veszélybe került</li>
                <li>elveszthetik alkalmazottaikat</li>
            </ul>
        <h3>Hogyan segíthetünk?</h3>
        <p> Az első lépés egy online kézfogás, avagy az előrendelés. A következő pedig már egy személyes lesz, amikor igénybe is veszed a szolgáltatást. <br> Az előrendelés a bevétel nélkül maradt vállalkozás számára segít talpon maradni a krízis idején, amikor pedig a járvány után helyreáll a normális élet, a rendelés ellenértékét le tudod vásárolni a vállalkozónál.<br></p>
        <h3>A közösség segítségével ismét bizalmat szavazhatunk kedvenc éttermünknek, pékségünknek, autószerelőnknek…bármilyen vállalkozásnak, ezzel segítve a talpraállásukat és megmaradásukat.</h3>
   
    </div>
</template>

<script>
export default {
    name:"AboutInitiative"
}
</script>

<style scoped>

 .about_the_initiative-container {
    margin: 100px 0 100px  0;
    padding: 0 25%;
    line-height: 25px;
} 

</style>